<template>
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.8723 31.2405L27.7645 24.6166C26.7126 23.8516 25.2874 23.8516 24.2355 24.6166L15.1277 31.2405C12.778 32.9494 13.9868 36.6667 16.8922 36.6667H35.1078C38.0132 36.6667 39.222 32.9494 36.8723 31.2405Z"
      fill="var(--sf-illustration-primary-background-primary)"
    />
    <path
      d="M22 20.3333L32.8723 28.2405C35.222 29.9494 34.0132 33.6667 31.1078 33.6667H12.8922C9.98678 33.6667 8.77797 29.9494 11.1277 28.2405L22 20.3333ZM22 20.3333V18.718C22 17.7083 22.6872 16.8282 23.6667 16.5833C24.6462 16.3385 25.3333 15.4584 25.3333 14.4487V13.3333C25.3333 11.6765 23.9902 10.3333 22.3333 10.3333H21.6667C20.0098 10.3333 18.6667 11.6765 18.6667 13.3333V13.6667"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
